class MobileNavMenu {
  constructor() {
    this.$container = jQuery('.mad-mobile-navmenu__container');
    this.$navMenu = jQuery('.mad-mobile-navmenu');
    this.$navItems = jQuery('.mad-mobile-navmenu__item');
    this.$subItems = jQuery('.mad-mobile-navmenu__subitems');
    this.$closeButton = jQuery('.mad-mobile-navmenu__close');
    this.$itemToggles = jQuery('.mad-mobile-navmenu__item-toggle');

    this.init();
  }

  init() {
    this.$container.appendTo(document.body);
    gsap.set(this.$container, {
      x: '-100%',
      display: 'none'
    });

    // Open menu event
    jQuery('.mad-navbar__hamburger-button').on('click', (e) => {
      e.preventDefault();
      this.openNavMenu();
    });

    // Close menu event
    this.$closeButton.on('click', (e) => {
      e.preventDefault();
      this.closeNavMenu();
    });

    // Toggle subitems event
    this.$itemToggles.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const $toggle = jQuery(e.currentTarget);
      const $wrapper = $toggle.closest('.mad-mobile-navmenu__item-wrapper');

      if ($wrapper.hasClass('active')) {
        this.closeSubitems($wrapper);
      } else {
        this.openSubitems($wrapper);
      }
    });
  }

  openNavMenu() {
    jQuery('body').addClass('no-scroll');
    gsap.set(this.$container, {
      display: 'flex'
    });

    gsap.fromTo(this.$container, {
      x: '-100%'
    }, {
      x: 0,
      duration: 0.5,
      ease: 'power2.inOut'
    });
  }

  closeNavMenu() {
    jQuery('body').removeClass('no-scroll');
    gsap.to(this.$container, {
      x: '-100%',
      duration: 0.5,
      ease: 'power2.inOut',
      onComplete: () => {
        gsap.set(this.$container, {
          display: 'none'
        });
      }
    });
  }

  openSubitems($wrapper) {
    // Close only siblings on the same level
    const $siblings = $wrapper.siblings('.mad-mobile-navmenu__item-wrapper.active');
    $siblings.each((_, item) => {
      this.closeSubitems(jQuery(item));
    });

    // Only the direct subitems wrapper of this wrapper
    const $subitemsWrapper = $wrapper.children('.mad-mobile-navmenu__subitems-wrapper');

    if ($subitemsWrapper.length === 0) {
      return;
    }

    // Only the toggle icon inside this wrapper
    const $toggleIcon = $wrapper
      .children('.mad-mobile-navmenu__item')
      .find('.mad-mobile-navmenu__item-toggle-icon')
      .first();

    $wrapper.addClass('active');
    $toggleIcon.addClass('rotated');

    // start from 0 and animate to scrollHeight
    gsap.fromTo($subitemsWrapper, {
      height: 0
    }, {
      height: $subitemsWrapper.prop('scrollHeight'),
      duration: 0.3,
      ease: 'power2.inOut',
      onComplete: () => {
        // let the content define its height after the animation
        $subitemsWrapper.css('height', 'auto');
      }
    });
  }

  closeSubitems($wrapper) {
    const $subitemsWrapper = $wrapper.children('.mad-mobile-navmenu__subitems-wrapper');

    // Only the toggle icon inside this wrapper
    const $toggleIcon = $wrapper
      .children('.mad-mobile-navmenu__item')
      .find('.mad-mobile-navmenu__item-toggle-icon')
      .first();

    // Close all active descendants of this wrapper
    const $activeDescendants = $wrapper.find('.mad-mobile-navmenu__item-wrapper.active');
    $activeDescendants.each((_, item) => {
      const $childWrapper = jQuery(item);
      const $childSubitems = $childWrapper.children('.mad-mobile-navmenu__subitems-wrapper');
      const $childIcon = $childWrapper
        .children('.mad-mobile-navmenu__item')
        .find('.mad-mobile-navmenu__item-toggle-icon')
        .first();

      $childWrapper.removeClass('active');
      $childIcon.removeClass('rotated');
      gsap.set($childSubitems, { height: 0 });
    });

    $wrapper.removeClass('active');
    $toggleIcon.removeClass('rotated');

    gsap.to($subitemsWrapper, {
      height: 0,
      duration: 0.3,
      ease: 'power2.inOut'
    });
  }
}

module.exports = MobileNavMenu;
